// src/ui/AuthorBadge.jsx
import React from "react";

export default function AuthorBadge({ children }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-gray-900 text-white px-2.5 py-1 text-xs">
      {children}
    </span>
  );
}
